import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Button from 'components/shared/Button/Button';

const NotFound = ({
  icon = 'Illustration-search-services',
  iconSize,
  iconClassName,
  title = '',
  titleClassName,
  description = '',
  descriptionClassName,
  createText = '',
  createIcon = 'add-square-mono',
  onCreate = () => {},
  createDisabled = false,
  createTooltip,
  className,
  extraText = ''
}) => (
  <div
    className={cn('mx-auto flex h-full flex-col items-center justify-center sm:pt-8', className)}>
    {icon && <Icon icon={icon} size={iconSize} className={iconClassName} />}
    {title && (
      <p
        className={cn(
          '!px-4 !pb-1 text-center text-base font-600 text-primary-900',
          titleClassName
        )}>
        {title}
      </p>
    )}
    {description && (
      <p
        className={cn(
          '!px-4 text-center text-sm leading-6 text-neutral-600',
          descriptionClassName
        )}>
        {description}
      </p>
    )}
    {extraText && (
      <p className="mt-5 !px-4 text-center text-sm leading-6 text-neutral-600">{extraText}</p>
    )}
    {createText && (
      <Button
        text={createText}
        onClick={onCreate}
        icon={createIcon}
        iconSize={18}
        className="!mt-3"
        variant="link"
        isDisabled={createDisabled}
        tooltip={createTooltip}
      />
    )}
  </div>
);

export default NotFound;
